// custom typefaces
import "@fontsource/averia-libre";
import "@fontsource/kanit";

import { AnimatePresence, LazyMotion, domAnimation } from "framer-motion";
import React from "react";

export const wrapPageElement = ({ element }) => <LazyMotion features={domAnimation}><AnimatePresence>{element}</AnimatePresence></LazyMotion>;
